<template>
  <div class="news-detail">
    <el-card v-loading="loading">
      <!-- 新闻头部 -->
      <div class="news-header">
        <h1 class="news-title">{{ news.title }}</h1>
        
        <div class="news-meta">
          <span class="meta-item">
            <el-icon><User /></el-icon>
            作者：{{ news.author }}
          </span>
          <span class="meta-item">
            <el-icon><Clock /></el-icon>
            发布时间：{{ news.publish_time }}
          </span>
          <span class="meta-item">
            <el-icon><View /></el-icon>
            浏览量：{{ news.view_count }}
          </span>
        </div>
        
        <div class="news-tags" v-if="news.is_top || news.is_hot || news.is_recommend">
          <el-tag v-if="news.is_top" type="danger">置顶</el-tag>
          <el-tag v-if="news.is_hot" type="warning">热门</el-tag>
          <el-tag v-if="news.is_recommend" type="success">推荐</el-tag>
        </div>
      </div>

      <!-- 新闻封面 -->
      <div class="news-cover" v-if="news.cover">
        <el-image
          :src="news.cover"
          fit="cover"
        >
          <template #error>
            <div class="image-slot">
              <el-icon><Picture /></el-icon>
            </div>
          </template>
        </el-image>
      </div>

      <!-- 新闻内容 -->
      <div class="news-content" v-html="news.content"></div>

      <!-- 返回按钮 -->
      <div class="news-footer">
        <el-button @click="goBack">返回列表</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import newsApi from '@/api/news'
import { User, Clock, View, Picture } from '@element-plus/icons-vue'

export default {
  name: 'NewsDetail',
  
  components: {
    User,
    Clock,
    View,
    Picture
  },
  
  data() {
    return {
      news: {},
      loading: false
    }
  },
  
  mounted() {
    this.loadNewsDetail()
  },
  
  methods: {
    /**
     * 加载新闻详情
     */
    async loadNewsDetail() {
      const newsId = this.$route.params.id
      
      if (!newsId) {
        this.$message.error('新闻ID不存在')
        this.$router.back()
        return
      }
      
      this.loading = true
      
      try {
        const res = await newsApi.getNewsDetail(newsId)
        
        if (res && res.code === 2000) {
          this.news = res.data
        }
      } catch (error) {
        console.error('加载新闻详情失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    /**
     * 返回列表
     */
    goBack() {
      this.$router.push('/news/list')
    }
  }
}
</script>

<style lang="scss" scoped>
.news-detail {
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f7fa;
  
  .el-card {
    max-width: 900px;
    margin: 0 auto;
  }
  
  .news-header {
    padding-bottom: 20px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 30px;
    
    .news-title {
      margin: 0 0 20px 0;
      font-size: 28px;
      color: #303133;
      line-height: 1.4;
    }
    
    .news-meta {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      margin-bottom: 15px;
      
      .meta-item {
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 14px;
        color: #606266;
        
        .el-icon {
          color: #909399;
        }
      }
    }
    
    .news-tags {
      display: flex;
      gap: 10px;
    }
  }
  
  .news-cover {
    margin-bottom: 30px;
    border-radius: 8px;
    overflow: hidden;
    
    .el-image {
      width: 100%;
      max-height: 500px;
    }
    
    .image-slot {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 300px;
      background-color: #f5f7fa;
      color: #909399;
      font-size: 60px;
    }
  }
  
  .news-content {
    line-height: 2;
    color: #303133;
    font-size: 16px;
    
    :deep(img) {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 20px auto;
    }
    
    :deep(p) {
      margin: 15px 0;
      text-indent: 2em;
    }
    
    :deep(h1), :deep(h2), :deep(h3) {
      margin: 25px 0 15px 0;
      text-indent: 0;
    }
  }
  
  .news-footer {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #e4e7ed;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .news-detail {
    padding: 10px;
    
    .news-header {
      .news-title {
        font-size: 22px;
      }
      
      .news-meta {
        flex-direction: column;
        gap: 10px;
      }
    }
    
    .news-content {
      font-size: 15px;
    }
  }
}
</style>
